<template>
  <div>
    <filter-manager
      ref="filter"
      :displayAdvanced="false"
      v-model="filter.model"
      :filters="filtersHeader"
      class="filter-manager_extended"
      search-container-class="search-btn"
      @search="onSearchHandler()"
    />

    <custom-separator class="my-3 custom-separator" text="Resultados" />

    <div v-if="hasResults">
      <student-result-row
        v-for="(item, index) in results"
        :key="index"
        :item="item"
        :actions-to-show="resultRowActions"
        @open="handlerOpen"
        @close="handlerClose"
        @refresh="() => onSearchHandler(pagination.currentPage)"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onSearchHandler"
      />
    </div>

    <custom-result-not-found
      v-if="!hasResults"
      text="No hay Información Disponible."
    />
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import storeMixin from '@/mixin/storeGenerator';
import alertMixin from '@/mixin/alert.mixin';
import inventoryOrderMaterialsAndEquipments from '@/services/api/inventoryOrderMaterialsAndEquipments.api';
import StudentResultRow from '../components/StudentResultRow.vue';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import ACTIONS from '@/utils/constants/inventoryBookRowActions';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';

const DEFAULT_PAGE_SIZE = 10;

export default {
  name: 'StudentsWithBooks',
  components: {
    ActionButton,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    StudentResultRow,
  },
  mixins: [alertMixin, storeMixin],
  data: () => ({
    loading: false,
    filter: {
      model: {
        studentNameSieOrRequestCode: null,
      },
    },
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: DEFAULT_PAGE_SIZE,
    },
    results: [],
  }),
  destroyed() {
    if (this.$route.name === 'inventoryOrderBooks') {
      this.resetStudentSearch();
    } else {
      this.persistData();
    }
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    hasResults() {
      return Boolean(this.results?.length);
    },
    resultRowActions() {
      return [ACTIONS.ViewAllBooksAssigned];
    },
    filtersHeader() {
      return [
        {
          name: 'studentNameSieOrRequestCode',
          component: 'CustomInput',
          placeholder:
            'Escriba Nombre del Estudiante  / SIE o Número de Solicitud',
          class: 'col-12 d-flex flex-column',
          type: 'text',
        },
      ];
    },
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData() {
      await this.onSearchHandler();
    },
    async onSearchHandler(currentPage = 1) {
      const { studentNameSieOrRequestCode } = this.filter.model;
      const { pageSize } = this.pagination;

      const {
        data,
      } = await inventoryOrderMaterialsAndEquipments.searchStudentsWithMaterial(
        {
          studentNameSieOrRequestCode,
          pageIndex: currentPage,
          pageSize,
        }
      );

      this.results = data.data.map((x) => ({
        ...x,
        isOpen: false,
        selected: false,
      }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async handlerOpen(item) {
      this.results
        .filter((x) => x.id !== item.id && x.isOpen)
        .forEach((x) => (x.isOpen = false));

      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    },
    resetStudentSearch() {
      this.filter.model.studentNameSieOrRequestCode = null;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .font-weight-bold {
  font-weight: 700 !important;
}

.actions-dropdown ::v-deep #dropdownMenuButton {
  color: #11291b !important;
}
</style>

<style></style>
